import styled from 'styled-components';
import { mediaQueries } from 'developer-docs-shared-components/utils/mediaQueries';
import { CARD_BORDER_RADIUS, CARD_BOX_SHADOW, INNER_CARD_PADDING } from 'developer-docs-shared-components/config/cssConstants';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const Wrapper = styled(UICardWrapper).withConfig({
  displayName: "Card__Wrapper",
  componentId: "c4oa2y-0"
})(["box-shadow:", ";border-radius:", "px;margin:32px 0 !important;"], CARD_BOX_SHADOW, CARD_BORDER_RADIUS);
const CardSection = styled(UICardSection).withConfig({
  displayName: "Card__CardSection",
  componentId: "c4oa2y-1"
})(["padding:", "px;height:100%;", "{padding:", "px;}"], INNER_CARD_PADDING, mediaQueries.belowTablet, INNER_CARD_PADDING);

/**
 * The new card variant. Eventually all cards will be migrated to the new
 * card component, so use this for UX consistency.
 *
 * TODO: From sync with Brett on Sept 22, add docs explaining why there are
 * two (ContentCard and Card). Apply grey BG when on in-app theme. Make
 * multiple card variant for eventual migration from extracted card to new
 * designed card.
 */
const Card = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Wrapper, {
    children: /*#__PURE__*/_jsx(CardSection, {
      children: children
    })
  });
};
export default Card;